<div class="campaign-container">
  <div class="campaign-header">
    <h2>{{ isNew ? 'Nowa kampania' : 'Edytuj kampanię' }}</h2>
  </div>

  <div class="campaign-body">
    @if (loading) {
      <div class="canter">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    @if (error) {
      <div class="error-msg">{{ error }}</div>
    }

    @if (!loading) {
      <form [formGroup]="form" (ngSubmit)="save()" class="campaign-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nazwa kampanii</mat-label>
          <input matInput formControlName="name" />
          @if (form.get('name')?.hasError('required')) {
            <mat-error>Pole wymagane</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Opis kampanii</mat-label>
          <textarea matInput formControlName="description" rows="3" placeholder="Opcjonalny opis kampanii..."></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Aktywna</mat-label>
          <mat-select formControlName="active" [compareWith]="compareActive">
            <mat-option [value]="1">Tak</mat-option>
            <mat-option [value]="0">Nie</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Ważna do</mat-label>
          <input matInput [matDatepicker]="pickerValid" formControlName="valid" />
          <mat-datepicker-toggle matSuffix [for]="pickerValid"></mat-datepicker-toggle>
          <mat-datepicker #pickerValid></mat-datepicker>
        </mat-form-field>
        <mat-divider class="section-divider"></mat-divider>
        <p class="section-label">Punkty</p>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Punkty za wejście</mat-label>
          <input matInput type="number" formControlName="point_per_entry" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Punkty za transakcję (ilość punkt. za 1zł)</mat-label>
          <input matInput type="number" formControlName="point_per_transaction" />
        </mat-form-field>
        <mat-divider class="section-divider"></mat-divider>
        <p class="section-label">Limity</p>
        <!-- Helper inputs that build limitation_for_transaction -->
        <div class="entry-limit-group full-width">
          <p class="entry-limit-group__title">Limit transakcji</p>
          <div class="entry-limit-inputs">
            <mat-form-field appearance="outline" class="entry-limit-field">
              <mat-label>Liczba transakcji</mat-label>
              <input matInput type="number" min="0" formControlName="_trans_count" placeholder="np. 5" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="entry-limit-field">
              <mat-label>Okres</mat-label>
              <mat-select formControlName="_trans_period">
                <mat-option value="d">Dzień</mat-option>
                <mat-option value="w">Tydzień</mat-option>
                <mat-option value="m">Miesiąc</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="entry-limit-field">
              <mat-label>Kwota minimum</mat-label>
              <input matInput type="number" min="0" formControlName="_trans_min" placeholder="np. 10" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="entry-limit-field">
              <mat-label>Kwota maksymalna</mat-label>
              <input matInput type="number" min="0" formControlName="_trans_max" placeholder="np. 1000" />
            </mat-form-field>
          </div>
          @if (transLimitPreview) {
            <div class="entry-limit-preview">
              <span class="entry-limit-preview__label">Wartość:</span>
              <code class="entry-limit-preview__value">{{ transLimitPreview }}</code>
            </div>
          }
        </div>
        <!-- Helper inputs that build limitation_for_entry -->
        <div class="entry-limit-group">
          <p class="entry-limit-group__title">Limit wejść</p>
          <div class="entry-limit-inputs">
            <mat-form-field appearance="outline" class="entry-limit-field">
              <mat-label>Limit wejść / dzień</mat-label>
              <input matInput type="number" min="0" formControlName="_entry_per_day" placeholder="np. 5" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="entry-limit-field">
              <mat-label>Limit wejść / tydzień</mat-label>
              <input matInput type="number" min="0" formControlName="_entry_per_week" placeholder="np. 10" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="entry-limit-field">
              <mat-label>Limit wejść / miesiąc</mat-label>
              <input matInput type="number" min="0" formControlName="_entry_per_month" placeholder="np. 20" />
            </mat-form-field>
          </div>
          @if (entryLimitPreview) {
            <div class="entry-limit-preview">
              <span class="entry-limit-preview__label">Wartość:</span>
              <code class="entry-limit-preview__value">{{ entryLimitPreview }}</code>
            </div>
          }
        </div>
      </form>
    }
  </div>

  <div class="campaign-footer">
    <button type="button" mat-stroked-button (click)="cancel()">
      <mat-icon>arrow_back</mat-icon> Anuluj
    </button>
    <button type="submit" mat-raised-button class="custom-button" [disabled]="saving" (click)="save()">
      @if (saving) {
        <mat-spinner diameter="18" class="btn-spinner"></mat-spinner>
      }
      @if (!saving) {
        <mat-icon>save</mat-icon>
      }
      {{ isNew ? 'Utwórz' : 'Zapisz' }}
    </button>
  </div>
</div>